// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-header h1 {
    font-size: 2.5em;
    color: #333;
    font-family: "Rigidica Text Bold", sans-serif;
}

.home-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
    margin-top: 20px;
}

.home-product-section {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.home-essaywriter-title {
    font-family: "Rigidica Text Bold", sans-serif;
    font-size: 3em;
    color: #333;
    margin-bottom: 20px;
    margin-left: 145px;
}

.home-product-content {
    display: flex;
    width: 100%;
    gap: 20px;
}

.home-product-image {
    max-width: 50%;
    height: auto;
}

.home-product-details {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
}

.home-product-details h2 {
    font-family: "Rigidica Text Bold", sans-serif;
    color: #333;
    margin-bottom: 10px;
}

.home-product-description {
    font-family: "Rigidica Text Regular", sans-serif;
    color: #666;
    line-height: 1.6;
    margin-bottom: 20px;
}

.home-price-display {
    margin-bottom: 20px;
}

.home-product-price {
    font-family: "Rigidica Text Bold", sans-serif;
    font-size: 1.5rem;
    color: #333;
}

.home-purchase-section {
    display: flex;
    align-items: center;
    gap: 20px;
}

.home-quantity-button,
.home-buy-button {
    font-family: "Rigidica Text Regular", sans-serif;
    background-color: #333;
    color: #fff;
    border-radius: 4px;
    border: none;
    padding: 15px 20px;
    font-size: 1rem;
    cursor: pointer;
    transition: background-color 0.3s;
}

.home-quantity-button {
    display: flex;
    align-items: center;
    padding: 0;
}

.home-quantity-display {
    padding: 15px 20px;
}

.home-quantity-controls {
    display: flex;
}

.home-quantity-controls span {
    cursor: pointer;
    padding: 15px 20px;
    border-left: 1px solid rgba(255, 255, 255, 0.3);
}

.home-quantity-button:hover,
.home-buy-button:hover {
    background-color: #555;
}

.home-popupContainer {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.75);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
    backdrop-filter: blur(5px);
    transition: all 0.3s ease;
}

.home-popupContent {
    background-color: #fff;
    padding: 30px;
    border-radius: 12px;
    max-width: 550px;
    width: 90%;
    max-height: 85vh;
    overflow-y: auto;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
    transform: translateY(0);
    transition: transform 0.3s ease;
    position: relative;
}

.home-popupTitle {
    font-family: "Rigidica Text Bold", sans-serif;
    font-size: 1.8em;
    margin-bottom: 20px;
    color: #222;
    text-align: left;
}

.home-popupMessage {
    font-size: 1em;
    margin-bottom: 25px;
    color: #333;
    text-align: left;
}

.home-divider {
    border: none;
    height: 1px;
    background-color: #eee;
    margin: 0 0 20px 0;
}

.home-popupContent-button {
    padding: 12px 24px;
    background-color: #333;
    color: white;
    border: none;
    border-radius: 4px;
    font-family: "Rigidica Text Regular", sans-serif;
    font-size: 16px;
    cursor: pointer;
    text-decoration: none;
    transition: background-color 0.3s ease;
    display: block;
    margin-left: auto;
    margin-right: auto;
}

.home-popupContent-button:hover {
    background-color: #555;
}

.home-read-more-button {
    font-family: "Rigidica Text Regular", sans-serif;
    background-color: transparent;
    color: #333;
    border: 1px solid #333;
    padding: 5px 10px;
    font-size: 0.9rem;
    cursor: pointer;
    border-radius: 4px;
    transition: background-color 0.3s, color 0.3s;
    margin-top: 10px;
    margin-bottom: 20px;
}

.home-read-more-button:hover {
    background-color: #333;
    color: #fff;
}

.home-product-features {
    text-align: left;
    margin-bottom: 30px;
}

.home-product-features h3 {
    font-family: "Rigidica Text Bold", sans-serif;
    font-size: 1.3rem;
    margin-bottom: 15px;
    color: #222;
}

.home-product-features ul {
    font-family: "Rigidica Text Regular", sans-serif;
    list-style-type: none;
    margin-left: 0;
    margin-bottom: 20px;
}

.home-product-features li {
    margin-bottom: 10px;
    padding-left: 25px;
    position: relative;
}

.home-product-features li::before {
    content: "•";
    position: absolute;
    left: 0;
    color: #333;
    font-weight: bold;
}

.home-compatibility {
    font-family: "Rigidica Text Light", sans-serif;
    font-size: 0.95rem;
    color: #444;
    background-color: #f5f5f5;
    padding: 15px;
    border-radius: 6px;
    margin-top: 15px;
}

.home-legal-footer {
    font-family: "Rigidica Text Light", sans-serif;
    font-size: 0.85rem;
    color: #888;
    margin-top: 30px;
    border-top: 1px solid #eee;
    padding-top: 15px;
}

.home-legal-link {
    color: #888;
}

/* CSS Media Queries */

@media screen and (max-width: 599px) {
    .home-container {
        padding: 10px;
    }

    .home-essaywriter-title {
        font-size: 2em;
        margin-left: 0;
        text-align: center;
        width: 100%;
    }

    .home-product-content {
        flex-direction: column;
    }

    .home-product-image {
        max-width: 100%;
        margin-bottom: 20px;
    }

    .home-product-details h2 {
        font-size: 1.5rem;
    }

    .home-purchase-section {
        flex-direction: column;
        align-items: stretch;
        width: 100%;
    }

    .home-quantity-button {
        width: 100%;
        margin-bottom: 10px;
        justify-content: space-between;
    }

    .home-buy-button {
        width: 100%;
    }

    .home-popupContent {
        padding: 20px;
        width: 95%;
    }

    .home-popupTitle {
        font-size: 1.5em;
    }

    .home-product-price {
        font-size: 1.3rem;
    }
}

@media screen and (min-width: 600px) and (max-width: 767px) {
    .home-essaywriter-title {
        font-size: 2.5em;
        margin-left: 20px;
    }

    .home-product-content {
        flex-direction: column;
    }

    .home-product-image {
        max-width: 80%;
        margin: 0 auto 20px;
    }

    .home-purchase-section {
        flex-direction: row;
        flex-wrap: wrap;
    }

    .home-quantity-button,
    .home-buy-button {
        flex: 1 1;
        min-width: 150px;
    }

    .home-legal-footer {
        font-size: 0.8rem;
    }
}

@media screen and (min-width: 768px) and (max-width: 1023px) {
    .home-essaywriter-title {
        font-size: 2.7em;
        margin-left: 60px;
    }

    .home-product-content {
        flex-direction: row;
        gap: 15px;
    }

    .home-product-image {
        max-width: 45%;
    }

    .home-product-details {
        flex: 1 1;
    }

    .home-product-details h2 {
        font-size: 1.6rem;
    }

    .home-purchase-section {
        gap: 15px;
    }
}

@media screen and (min-width: 1024px) {
    .home-essaywriter-title {
        margin-left: 123px;
        font-size: 3em;
    }

    .home-product-content {
        gap: 30px;
    }

    .home-product-image {
        max-width: 45%;
    }

    .home-product-details {
        flex: 1 1;
    }

    .home-product-description {
        font-size: 1.1rem;
    }
}

@media screen and (max-width: 1280px) {
    .home-popupContent {
        margin-top: 60px;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/HomePage.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,WAAW;IACX,6CAA6C;AACjD;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,6CAA6C;IAC7C,cAAc;IACd,WAAW;IACX,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,SAAS;AACb;;AAEA;IACI,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,6CAA6C;IAC7C,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,gDAAgD;IAChD,WAAW;IACX,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,6CAA6C;IAC7C,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;;IAEI,gDAAgD;IAChD,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,+CAA+C;AACnD;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,qCAAqC;IACrC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,0CAA0C;IAC1C,wBAAwB;IACxB,+BAA+B;IAC/B,kBAAkB;AACtB;;AAEA;IACI,6CAA6C;IAC7C,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,gDAAgD;IAChD,eAAe;IACf,eAAe;IACf,qBAAqB;IACrB,sCAAsC;IACtC,cAAc;IACd,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gDAAgD;IAChD,6BAA6B;IAC7B,WAAW;IACX,sBAAsB;IACtB,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,6CAA6C;IAC7C,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,6CAA6C;IAC7C,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,gDAAgD;IAChD,qBAAqB;IACrB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,8CAA8C;IAC9C,kBAAkB;IAClB,WAAW;IACX,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,8CAA8C;IAC9C,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,0BAA0B;IAC1B,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA,sBAAsB;;AAEtB;IACI;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;QACd,cAAc;QACd,kBAAkB;QAClB,WAAW;IACf;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,sBAAsB;QACtB,oBAAoB;QACpB,WAAW;IACf;;IAEA;QACI,WAAW;QACX,mBAAmB;QACnB,8BAA8B;IAClC;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,aAAa;QACb,UAAU;IACd;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;QACnB,eAAe;IACnB;;IAEA;;QAEI,SAAO;QACP,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,mBAAmB;QACnB,SAAS;IACb;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,SAAO;IACX;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,SAAS;IACb;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,cAAc;IAClB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,SAAO;IACX;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ","sourcesContent":[".home-header h1 {\n    font-size: 2.5em;\n    color: #333;\n    font-family: \"Rigidica Text Bold\", sans-serif;\n}\n\n.home-container {\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 20px;\n    margin-top: 20px;\n}\n\n.home-product-section {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n}\n\n.home-essaywriter-title {\n    font-family: \"Rigidica Text Bold\", sans-serif;\n    font-size: 3em;\n    color: #333;\n    margin-bottom: 20px;\n    margin-left: 145px;\n}\n\n.home-product-content {\n    display: flex;\n    width: 100%;\n    gap: 20px;\n}\n\n.home-product-image {\n    max-width: 50%;\n    height: auto;\n}\n\n.home-product-details {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    text-align: left;\n}\n\n.home-product-details h2 {\n    font-family: \"Rigidica Text Bold\", sans-serif;\n    color: #333;\n    margin-bottom: 10px;\n}\n\n.home-product-description {\n    font-family: \"Rigidica Text Regular\", sans-serif;\n    color: #666;\n    line-height: 1.6;\n    margin-bottom: 20px;\n}\n\n.home-price-display {\n    margin-bottom: 20px;\n}\n\n.home-product-price {\n    font-family: \"Rigidica Text Bold\", sans-serif;\n    font-size: 1.5rem;\n    color: #333;\n}\n\n.home-purchase-section {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n}\n\n.home-quantity-button,\n.home-buy-button {\n    font-family: \"Rigidica Text Regular\", sans-serif;\n    background-color: #333;\n    color: #fff;\n    border-radius: 4px;\n    border: none;\n    padding: 15px 20px;\n    font-size: 1rem;\n    cursor: pointer;\n    transition: background-color 0.3s;\n}\n\n.home-quantity-button {\n    display: flex;\n    align-items: center;\n    padding: 0;\n}\n\n.home-quantity-display {\n    padding: 15px 20px;\n}\n\n.home-quantity-controls {\n    display: flex;\n}\n\n.home-quantity-controls span {\n    cursor: pointer;\n    padding: 15px 20px;\n    border-left: 1px solid rgba(255, 255, 255, 0.3);\n}\n\n.home-quantity-button:hover,\n.home-buy-button:hover {\n    background-color: #555;\n}\n\n.home-popupContainer {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.75);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1;\n    backdrop-filter: blur(5px);\n    transition: all 0.3s ease;\n}\n\n.home-popupContent {\n    background-color: #fff;\n    padding: 30px;\n    border-radius: 12px;\n    max-width: 550px;\n    width: 90%;\n    max-height: 85vh;\n    overflow-y: auto;\n    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);\n    transform: translateY(0);\n    transition: transform 0.3s ease;\n    position: relative;\n}\n\n.home-popupTitle {\n    font-family: \"Rigidica Text Bold\", sans-serif;\n    font-size: 1.8em;\n    margin-bottom: 20px;\n    color: #222;\n    text-align: left;\n}\n\n.home-popupMessage {\n    font-size: 1em;\n    margin-bottom: 25px;\n    color: #333;\n    text-align: left;\n}\n\n.home-divider {\n    border: none;\n    height: 1px;\n    background-color: #eee;\n    margin: 0 0 20px 0;\n}\n\n.home-popupContent-button {\n    padding: 12px 24px;\n    background-color: #333;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    font-family: \"Rigidica Text Regular\", sans-serif;\n    font-size: 16px;\n    cursor: pointer;\n    text-decoration: none;\n    transition: background-color 0.3s ease;\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.home-popupContent-button:hover {\n    background-color: #555;\n}\n\n.home-read-more-button {\n    font-family: \"Rigidica Text Regular\", sans-serif;\n    background-color: transparent;\n    color: #333;\n    border: 1px solid #333;\n    padding: 5px 10px;\n    font-size: 0.9rem;\n    cursor: pointer;\n    border-radius: 4px;\n    transition: background-color 0.3s, color 0.3s;\n    margin-top: 10px;\n    margin-bottom: 20px;\n}\n\n.home-read-more-button:hover {\n    background-color: #333;\n    color: #fff;\n}\n\n.home-product-features {\n    text-align: left;\n    margin-bottom: 30px;\n}\n\n.home-product-features h3 {\n    font-family: \"Rigidica Text Bold\", sans-serif;\n    font-size: 1.3rem;\n    margin-bottom: 15px;\n    color: #222;\n}\n\n.home-product-features ul {\n    font-family: \"Rigidica Text Regular\", sans-serif;\n    list-style-type: none;\n    margin-left: 0;\n    margin-bottom: 20px;\n}\n\n.home-product-features li {\n    margin-bottom: 10px;\n    padding-left: 25px;\n    position: relative;\n}\n\n.home-product-features li::before {\n    content: \"•\";\n    position: absolute;\n    left: 0;\n    color: #333;\n    font-weight: bold;\n}\n\n.home-compatibility {\n    font-family: \"Rigidica Text Light\", sans-serif;\n    font-size: 0.95rem;\n    color: #444;\n    background-color: #f5f5f5;\n    padding: 15px;\n    border-radius: 6px;\n    margin-top: 15px;\n}\n\n.home-legal-footer {\n    font-family: \"Rigidica Text Light\", sans-serif;\n    font-size: 0.85rem;\n    color: #888;\n    margin-top: 30px;\n    border-top: 1px solid #eee;\n    padding-top: 15px;\n}\n\n.home-legal-link {\n    color: #888;\n}\n\n/* CSS Media Queries */\n\n@media screen and (max-width: 599px) {\n    .home-container {\n        padding: 10px;\n    }\n\n    .home-essaywriter-title {\n        font-size: 2em;\n        margin-left: 0;\n        text-align: center;\n        width: 100%;\n    }\n\n    .home-product-content {\n        flex-direction: column;\n    }\n\n    .home-product-image {\n        max-width: 100%;\n        margin-bottom: 20px;\n    }\n\n    .home-product-details h2 {\n        font-size: 1.5rem;\n    }\n\n    .home-purchase-section {\n        flex-direction: column;\n        align-items: stretch;\n        width: 100%;\n    }\n\n    .home-quantity-button {\n        width: 100%;\n        margin-bottom: 10px;\n        justify-content: space-between;\n    }\n\n    .home-buy-button {\n        width: 100%;\n    }\n\n    .home-popupContent {\n        padding: 20px;\n        width: 95%;\n    }\n\n    .home-popupTitle {\n        font-size: 1.5em;\n    }\n\n    .home-product-price {\n        font-size: 1.3rem;\n    }\n}\n\n@media screen and (min-width: 600px) and (max-width: 767px) {\n    .home-essaywriter-title {\n        font-size: 2.5em;\n        margin-left: 20px;\n    }\n\n    .home-product-content {\n        flex-direction: column;\n    }\n\n    .home-product-image {\n        max-width: 80%;\n        margin: 0 auto 20px;\n    }\n\n    .home-purchase-section {\n        flex-direction: row;\n        flex-wrap: wrap;\n    }\n\n    .home-quantity-button,\n    .home-buy-button {\n        flex: 1;\n        min-width: 150px;\n    }\n\n    .home-legal-footer {\n        font-size: 0.8rem;\n    }\n}\n\n@media screen and (min-width: 768px) and (max-width: 1023px) {\n    .home-essaywriter-title {\n        font-size: 2.7em;\n        margin-left: 60px;\n    }\n\n    .home-product-content {\n        flex-direction: row;\n        gap: 15px;\n    }\n\n    .home-product-image {\n        max-width: 45%;\n    }\n\n    .home-product-details {\n        flex: 1;\n    }\n\n    .home-product-details h2 {\n        font-size: 1.6rem;\n    }\n\n    .home-purchase-section {\n        gap: 15px;\n    }\n}\n\n@media screen and (min-width: 1024px) {\n    .home-essaywriter-title {\n        margin-left: 123px;\n        font-size: 3em;\n    }\n\n    .home-product-content {\n        gap: 30px;\n    }\n\n    .home-product-image {\n        max-width: 45%;\n    }\n\n    .home-product-details {\n        flex: 1;\n    }\n\n    .home-product-description {\n        font-size: 1.1rem;\n    }\n}\n\n@media screen and (max-width: 1280px) {\n    .home-popupContent {\n        margin-top: 60px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
